<template>
  <div v-if="exibeAnuncio">
    <v-dialog v-model="adsDialog" :fullscreen="$vuetify.breakpoint.xs" max-width="450"
      transition="dialog-bottom-transition" persistent>
      <v-card v-if="exibeAnuncio && adsDialog"
        :style="'min-width: 450px; max-width: 100%; max-height:500px; overflow: auto; overflow-y: hidden; z-index:999;'">
        
        <!-- Anúncio do Google Adsense (oculto inicialmente) -->
        <div v-show="showGoogleAd" ref="googleAdContainer" style="min-height: 280px;">
          <Adsense
            v-if="showGoogleAd"
            :data-ad-client="googleAdClient"
            :data-ad-slot="googleAdSlot"
            data-ad-format="rectangle"
            :data-ad-test="isTestMode"
            :data-full-width-responsive="'true'"
            @load="onGoogleAdLoad"
            @error="onGoogleAdError"
          />
        </div>

        <!-- Anúncio próprio (fallback) -->
        <div v-if="showOwnAd">
          <Video 
            v-if="anuncioAtual.youtube_src" 
            :autoplay="true" 
            :repeat="true" 
            :href="anuncioAtual.link" 
            target="_blank"
            :src="anuncioAtual.youtube_src" 
            style="height: 400px;" 
          />
          <v-img 
            v-else 
            :src="anuncioAtual.img_src" 
            style="height: 400px; background-color: black;" 
            @error="onImageError"
          />
        </div>

        <!-- Spinner de carregamento -->
        <div v-if="loadingAd" class="text-center py-12">
          <v-progress-circular indeterminate size="64" width="6" color="primary" />
          <div class="mt-4">Carregando anúncio...</div>
        </div>

        <v-divider />
        <v-card-actions>
          <a @click="anuncioClique(anuncioAtual)" target="_blank" style="cursor: pointer; text-decoration: none;">
            {{ anuncioAtual.titulo }}
          </a>
          <v-spacer />
          <v-btn 
            v-if="mostraFecharDialog" 
            color="error" 
            @click="fecharDialog"
            :disabled="!fechamentoHabilitado"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn v-else color="error">
            <v-progress-circular :size="30" color="white" indeterminate />
            <span class="ml-2">{{ tempoRestante }}s</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ANUNCIO } from '../../utils/types'
import { mapState, mapMutations } from 'vuex';
import Video from './Video.vue';

export default {
  name: 'Anuncio30s',

  components: { Video },
  
  data: () => ({
    exibeAnuncio: false,
    adsDialog: false,
    mostraFecharDialog: false,
    tempoRestante: 30,
    timer: null,
    
    // Controle de anúncios
    showGoogleAd: false,
    showOwnAd: false,
    loadingAd: true,
    googleAdLoaded: false,
    fechamentoHabilitado: false,
    
    // Configurações do Google Adsense
    googleAdClient: 'ca-pub-5511611659398318',
    googleAdSlot: '2598340340',
    isTestMode: true, // Altere para false em produção
    
    // Lista de anúncios próprios (pode ser expandida)
    anunciosProprios: [
      {
        id: 1,
        titulo: 'Não quer ver esse tipo de anúncio? Contrate algum de nossos planos pago.',
        youtube_src: '6riNRsYl3Q8',
        img_src: null,
        link: 'https://brcorte.com.br/site/licenca?ref=ads&u=6riNRsYl3Q8',
        idioma: 0,
        tempo_pular: 30,
        tipo: 'video'
      },
      {
        id: 2,
        titulo: 'Quer remover os anúncios? Assine um plano pago.',
        youtube_src: 'Z8f4yfhjrZg',
        img_src: '/img/assine-nao-tenha-anuncios.png', // Caminho para imagem local
        link: 'https://brcorte.com.br/site/licenca?ref=ads&u=Z8f4yfhjrZg',
        idioma: 0,
        tempo_pular: 30,
        tipo: 'imagem'
      },
      {
        id: 3,
        titulo: 'Tenha uma experiência sem anúncios contratando um de nossos planos pagos.',
        youtube_src: 'H3azjTZxjRk',
        img_src: '/img/assine-nao-tenha-anuncios.png',
        link: 'https://brcorte.com.br/site/licenca?ref=ads&u=H3azjTZxjRk',
        idioma: 0,
        tempo_pular: 20,
        tipo: 'imagem'
      }
    ],
    
    // Anúncio atual sendo exibido
    anuncioAtual: null,
    
    // Configurações
    tempoTentativaGoogle: 3000, // 3 segundos para tentar carregar Google Ad
    alternarAutomatico: true,
    tempoAlternancia: 10000, // Alternar a cada 10 segundos (se habilitado)
    alternanciaTimer: null
  }),
  
  computed: {
    ...mapState('app', ['step', 'user', 'trava_back', 'curr_version', 'strings', 'idioma', 'dark']),
    
    // Seleciona anúncio próprio baseado no idioma
    anunciosPorIdioma() {
      return this.anunciosProprios.filter(ad => 
        ad.idioma === this.idioma || ad.idioma === 0
      );
    }
  },
  
  watch: {
    tempoRestante(val) {
      if (val <= 0) {
        this.mostraFecharDialog = true;
        this.fechamentoHabilitado = true;
        clearInterval(this.timer);
      }
    }
  },
  
  mounted() {
    window.addEventListener('exibir-anuncio-30s', this.inicializarAnuncio);
  },
  
  beforeDestroy() {
    window.removeEventListener('exibir-anuncio-30s', this.inicializarAnuncio)
    this.limparTimers();
  },
  
  methods: {
    ...mapMutations('app', ['setTravaBack']),
    
    inicializarAnuncio(event) {
      this.limparTimers();
      
      this.exibeAnuncio = this.getAcessoModulo({ user: this.user, modulo: ANUNCIO });
      
      if (!this.exibeAnuncio) return;

      this.adsDialog = true;
      
      // Reset estados
      this.showGoogleAd = false;
      this.showOwnAd = false;
      this.loadingAd = true;
      this.googleAdLoaded = false;
      this.mostraFecharDialog = false;
      this.fechamentoHabilitado = false;
      this.tempoRestante = 30;

      if (event) {
        console.log({ event})
        const { timer } = event.detail || {};
        console.log({ timer})
        if (timer) {
          this.tempoRestante = timer;
        }
      }
      
      // Seleciona anúncio próprio aleatório
      this.selecionarAnuncioProprio();
      
      // Tenta carregar anúncio do Google primeiro
      this.tentarCarregarGoogleAd();
      
      // Inicia contador para fechamento
      this.iniciarContadorFechamento();
    },
    
    tentarCarregarGoogleAd() {
      // Mostra Google Ad após pequeno delay para evitar flickering
      setTimeout(() => {
        this.showGoogleAd = true;
        this.loadingAd = true;
        
        // Timeout para fallback se Google Ad não carregar
        setTimeout(() => {
          if (!this.googleAdLoaded && this.showGoogleAd) {
            console.log('Google Ad não carregou, usando anúncio próprio');
            this.mostrarAnuncioProprio();
          }
        }, this.tempoTentativaGoogle);
      }, 500);
    },
    
    onGoogleAdLoad() {
      console.log('Google Ad carregado com sucesso');
      this.googleAdLoaded = true;
      this.loadingAd = false;
      this.showOwnAd = false;
      
      // Inicia alternância se configurado
      if (this.alternarAutomatico) {
        this.iniciarAlternancia();
      }
    },
    
    onGoogleAdError(error) {
      console.error('Erro ao carregar Google Ad:', error);
      this.mostrarAnuncioProprio();
    },
    
    mostrarAnuncioProprio() {
      this.showGoogleAd = false;
      this.showOwnAd = true;
      this.loadingAd = false;
      
      // Se não há anúncio próprio selecionado, seleciona um
      if (!this.anuncioAtual) {
        this.selecionarAnuncioProprio();
      }
    },
    
    selecionarAnuncioProprio() {
      if (this.anunciosPorIdioma.length === 0) {
        // Fallback padrão se não houver anúncios no idioma
        this.anuncioAtual = {
          id: 0,
          titulo: 'Menos anúncios, mais conteúdo. Conheça nossos planos pagos.',
          youtube_src: 'vsCqqQf5a2U',
          img_src: null,
          link: 'https://brcorte.com.br/site/licenca?ref=ads&u=vsCqqQf5a2U',
          idioma: 0,
          tempo_pular: 30,
          tipo: 'video'
        };
        return;
      }
      
      // Seleciona aleatoriamente um anúncio
      const randomIndex = Math.floor(Math.random() * this.anunciosPorIdioma.length);
      this.anuncioAtual = { ...this.anunciosPorIdioma[randomIndex] };
      
      // Ajusta tempo de fechamento baseado no anúncio
      this.tempoRestante = this.anuncioAtual.tempo_pular || 30;
    },
    
    onImageError() {
      console.log('Erro ao carregar imagem do anúncio próprio');
      // Tenta outro anúncio se a imagem falhar
      this.selecionarAnuncioProprio();
    },
    
    iniciarContadorFechamento() {
      this.timer = setInterval(() => {
        if (this.tempoRestante > 0) {
          this.tempoRestante--;
        }
      }, 1000);
    },
    
    iniciarAlternancia() {
      if (this.alternanciaTimer) {
        clearInterval(this.alternanciaTimer);
      }
      
      this.alternanciaTimer = setInterval(() => {
        if (this.showGoogleAd && this.googleAdLoaded) {
          // Alterna para anúncio próprio
          this.mostrarAnuncioProprio();
        } else if (this.showOwnAd) {
          // Tenta voltar para Google Ad
          this.tentarCarregarGoogleAd();
        }
      }, this.tempoAlternancia);
    },
    
    anuncioClique(anuncio) {
      if (anuncio && anuncio.link) {
        window.open(anuncio.link, '_blank');
        
        // Registra clique (pode ser enviado para analytics)
        this.registrarClique(anuncio);
      }
    },
    
    registrarClique(anuncio) {
      // Implemente o registro de cliques aqui
      console.log(`Clique registrado no anúncio: ${anuncio.titulo}`);
      // Exemplo: this.$trackEvent('ad_click', { ad_id: anuncio.id, ad_type: anuncio.tipo });
    },
    
    fecharDialog() {
      if (this.fechamentoHabilitado) {
        this.adsDialog = false;
        this.exibeAnuncio = false;
        this.limparTimers();
      }
    },
    
    limparTimers() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      
      if (this.alternanciaTimer) {
        clearInterval(this.alternanciaTimer);
        this.alternanciaTimer = null;
      }
    },
    
    getAcessoModulo({ user, modulo }) {
      // Implemente sua lógica de verificação de acesso aqui
      // Esta é uma função placeholder - substitua pela sua implementação real
      return true; // Exemplo: sempre exibe anúncio
    }
  }
}
</script>

<style scoped>
/* Estilos para melhorar a aparência */
.v-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.v-card-actions {
  padding: 12px 16px;
  background-color: #f5f5f5;
}

a {
  color: #1976d2;
  font-weight: 500;
  transition: color 0.3s;
}

a:hover {
  color: #0d47a1;
  text-decoration: underline;
}

/* Estilo para modo escuro */
.theme--dark .v-card-actions {
  background-color: #1e1e1e;
}

.theme--dark a {
  color: #90caf9;
}

.theme--dark a:hover {
  color: #42a5f5;
}
</style>